import { getEditorValueString } from 'components/property-editors/editors/EditorStringValueUtils';
import { ContextProviderNode } from '@decisions/server/DecisionsFramework/Design/Properties';
import { useEffect, useState } from 'react';
import { getMappedDataPath, getMappedValueNode, mappingTypeRendersInlineEditor } from '../utils/MappingUtils';
// import './StepMappedValueText.less'

interface IStepMappedValueTextProps {
  className?: string;
  node: ContextProviderNode;
  currentMapping: string; //In case of DateTime, we need to identify whether mapping is 'Constant Date' or 'Constant Date and Time' so on the basis of that we will show only Date or Date and Time both
}

/**
 * Simple Text readout of a node's value
 *
 * Copyright (c) 2021 Decisions All Rights Reserved
 */
export function StepMappedValueText({ className, node, currentMapping }: IStepMappedValueTextProps) {
  const mappedValue = getMappedDataPath(node, currentMapping);
  const mappedPathValue = mappedValue ? `Path: ${mappedValue}` : '';
  const formattedPath = mappedPathValue.replace(/\./g, ' / ');
  const isRenderInOverlay = mappingTypeRendersInlineEditor(currentMapping);
  const [valueString, setValueString] = useState(!isRenderInOverlay && formattedPath);

  useEffect(() => {
    (async () => {
      if (!isRenderInOverlay) {
        setValueString(formattedPath);
        return;
      }
      const value = getEditorValueString(getMappedValueNode(node), currentMapping);
      value.then(str => setValueString(str));
    })();
  }, [node, node.Children, currentMapping, isRenderInOverlay, formattedPath]);

  // could we use suspense here?
  return valueString ? (
    <div className={className} title={valueString}>
      {valueString}
    </div>
  ) : null;
}
